import { useEffect, useRef, useState } from "react";
import axios from "axios";
import styles from "./Filter.module.css";
import toast, { Toaster } from "react-hot-toast";

const Filter = ({ openFilter, setOpenFilter, setApiRequest, loading }) => {
  const containerRef = useRef();
  const [sportList, setSportList] = useState([]);
  const initialCheckboxState = {
    placesChecked: true,
    eventsChecked: true,
    activitiesChecked: true,
  };

  const [checkboxState, setCheckboxState] = useState(initialCheckboxState);
  const [selectedSportsState, setSelectedSportsState] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}get-sports`)
      .then((res) => {
        setSportList(res.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  useEffect(() => {
    containerRef.current.scrollTo(0, 0);
  }, [openFilter]);

  const changeSelectedSports = (id) => {
    const index = selectedSportsState.indexOf(id);
    if (index === -1) {
      setSelectedSportsState((prev) => [...prev, id]);
    } else {
      selectedSportsState.splice(index, 1);
      setSelectedSportsState([...selectedSportsState]);
    }
  };

  const changeCheckbox = (e, type) => {
    if (
      Object.values(checkboxState).filter((item) => item).length === 1 &&
      !e.target.checked
    ) {
      return;
    }
    setCheckboxState((prev) => ({
      ...prev,
      [type]: e.target.checked,
    }));
  };

  const setFilterData = () => {
    const checkboxArray = [];
    if (checkboxState.activitiesChecked) checkboxArray.push("ACTIVITIES");
    if (checkboxState.eventsChecked) checkboxArray.push("EVENTS");
    if (checkboxState.placesChecked) checkboxArray.push("PLACES");
    setApiRequest((prev) => ({
      ...prev,
      sports: selectedSportsState,
      data: checkboxArray,
    }));
  };

  return (
    <div
      className={`${styles.mainFilterContainer} ${
        openFilter ? styles.open : styles.close
      }`}
    >
      <div
        className={styles.outsideContainer}
        onClick={() => setOpenFilter(false)}
      ></div>
      <div
        ref={containerRef}
        className={`${styles.filterContainer} ${
          openFilter ? styles.filterShow : styles.filterHide
        }`}
      >
        <div className={styles.filterCloseContainer}>
          <p className={styles.reset} onClick={() => setOpenFilter(false)}>
            Close
          </p>
        </div>
        <div className={styles.filterHeadContainer}>
          <p className={styles.filterHeading}>Filters</p>
          <p
            className={styles.reset}
            onClick={() => setSelectedSportsState([])}
          >
            Reset
          </p>
        </div>
        <div className={styles.typeContainer}>
          <div className={styles.singleType}>
            <p className={styles.typeLabel}>Places</p>
            <label className={styles.container}>
              <input
                type="checkbox"
                name=""
                id=""
                checked={checkboxState.placesChecked}
                onChange={(e) => changeCheckbox(e, "placesChecked")}
              />
              <span className={styles.checkmark}></span>
            </label>
          </div>
          <div className={styles.singleType}>
            <p className={styles.typeLabel}>Events</p>
            <label className={styles.container}>
              <input
                type="checkbox"
                name=""
                id=""
                checked={checkboxState.eventsChecked}
                onChange={(e) => changeCheckbox(e, "eventsChecked")}
              />
              <span className={styles.checkmark}></span>
            </label>
          </div>
          <div className={styles.singleType}>
            <p className={styles.typeLabel}>Activities</p>
            <label className={styles.container}>
              <input
                type="checkbox"
                name=""
                id=""
                checked={checkboxState.activitiesChecked}
                onChange={(e) => changeCheckbox(e, "activitiesChecked")}
              />
              <span className={styles.checkmark}></span>
            </label>
          </div>
        </div>
        <p className={styles.selectSportText}>Select Sport</p>
        <div className={styles.sportsContainer}>
          {sportList.map((sport) => (
            <div
              key={sport.id}
              className={styles.sport}
              style={{
                border: selectedSportsState.includes(sport.id)
                  ? "2px solid #3CC0A0"
                  : "2px solid #222423",
              }}
              onClick={() => changeSelectedSports(sport.id)}
            >
              <img src={sport.icon} alt={sport.name} height={15} width={15} />
              <p className={styles.sportName}>{sport.name}</p>
            </div>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <button type="button" disabled={loading} onClick={setFilterData}>
            Apply
          </button>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default Filter;
